import { getUser } from '@frontend/auth-helpers';

export const SOFTPHONE_DISCONNECT_WARNING_STORAGE_KEY = 'softphone.show-disconnect-warning';

export const getSoftphoneDisconnectWarningStorageKey = (userId?: string) =>
  `${SOFTPHONE_DISCONNECT_WARNING_STORAGE_KEY}:${userId ?? 'unknown-user'}`;

export const getCurrentUserSoftphoneDisconnectWarningStorageKey = () =>
  getSoftphoneDisconnectWarningStorageKey(getUser()?.userID);
